<template>
  <transition name="popup" :duration="500" v-on:before-leave="beforeLeave" @leave="leave">
    <div class="vi-popup" :class="{ [popupClass] : true, 'vi-popup-enter': isOpening,  'vi-popup-leave': isClosing}" v-if="value">

      <div class="background-blur" @click="$emit('input', false)">

      </div>

      <div class="popup-content-container">
        <div class="close-popup" @click="$emit('input', false)">
          <img src="../../assets/close-icon.svg">
        </div>

        <div class="popup-content">
          <slot></slot>
        </div>

        <div @click="$emit('input', false)" class="back-button caps-medium">
          <svg width="26" height="16" viewBox="0 0 26 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M24.7257 8.70711C25.1162 8.31658 25.1162 7.68342 24.7257 7.2929L18.3617 0.928934C17.9712 0.538409 17.338 0.538409 16.9475 0.928934C16.557 1.31946 16.557 1.95262 16.9475 2.34315L22.6043 8L16.9475 13.6569C16.557 14.0474 16.557 14.6805 16.9475 15.0711C17.338 15.4616 17.9712 15.4616 18.3617 15.0711L24.7257 8.70711ZM0.0185546 9L24.0186 9L24.0186 7L0.0185548 7L0.0185546 9Z" fill="#1B1C1D"/>
          </svg>

          BACK
        </div>

      </div>

    </div>
  </transition>

</template>

<script>
export default {
  name: 'ViPopup',
  props: {
    value: {
      type: Boolean
    },
    popupClass:{
      type:String
    }
  },

  data: () => ({
    isOpening: false,
    isClosing: false
  }),

  methods: {
    beforeLeave() {
      this.isClosing = true
      console.log('beforeLeave')
    },

    leave: function (el, done) {
      console.log('leave', el)
      this.isClosing = false
      done()
    },
  },

  watch: {
    value() {
      if(this.value) {
        this.isOpening = true
        setTimeout(() => {
          this.isOpening = false
        }, 10)
      }
    }
  }

}
</script>

<style lang="scss">
@import "ViPopup.scss";
</style>
